import { AbstractControl } from '@angular/forms';

export class SpaceValidation {
  public checkSpaceValidation(control: AbstractControl) {
    const isWhiteSpace = control.value && control.value.startsWith(' ');
    return isWhiteSpace ? { 'whitespace': true } : null;
  }
}
